
import Api from './api'

export default {
    get: function (email) {

        return Api.get(`/auth/mx/${ email }`)
            .then(data => {
                switch (data.provider) {
                    case 'microsoft':
                        return {
                            ...data,
                            provider: 'outlook'
                        }
                    default:
                        return data
                }
            })

    }
}
